import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  max-height: 70vh;
  overflow-y: auto;
  padding: 20px;
  line-height: 1.6;
  color: #333;
  
  /* 滚动条样式 */
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 10px;
  text-align: center;
`;

const UpdateDate = styled.p`
  font-size: 14px;
  color: #7f8c8d;
  text-align: center;
  margin-bottom: 20px;
`;

const Introduction = styled.p`
  font-size: 16px;
  margin-bottom: 25px;
  padding: 15px;
  background-color: #f8f9fa;
  border-left: 4px solid #3498db;
  border-radius: 4px;
`;

const Section = styled.section`
  margin-bottom: 30px;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #2c3e50;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 2px solid #ecf0f1;
`;

const SubSection = styled.div`
  margin-bottom: 20px;
`;

const SubSectionTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #34495e;
  margin-bottom: 10px;
`;

const Paragraph = styled.p`
  font-size: 15px;
  margin-bottom: 12px;
  text-align: justify;
`;

const BulletList = styled.ul`
  margin: 10px 0;
  padding-left: 20px;
`;

const BulletItem = styled.li`
  font-size: 15px;
  margin-bottom: 8px;
  line-height: 1.5;
`;

const ContactInfo = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-top: 30px;
  border: 1px solid #e9ecef;
`;

const ContactTitle = styled.h3`
  font-size: 16px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 15px;
`;

const ContactItem = styled.p`
  font-size: 15px;
  margin-bottom: 8px;
  color: #495057;
`;

const PrivacyPolicy: React.FC = () => {
  return (
    <Container>
      <Title>隐私政策</Title>
      <UpdateDate>更新日期：2025年11月7日</UpdateDate>
      
      <Introduction>
        湖州厨记科技有限公司（以下简称&quot;我们&quot;）深知个人信息对您的重要性，我们将按照法律法规要求，采取相应安全保护措施，尽力保护您的个人信息安全可控。
      </Introduction>

      <Section>
        <SectionTitle>一、我们如何收集和使用您的个人信息</SectionTitle>
        
        <SubSection>
          <SubSectionTitle>1.1 账号注册</SubSectionTitle>
          <Paragraph>
            当您注册账号时，我们会收集您的手机号码，用于创建账号和保护账号安全。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>1.2 使用服务</SubSectionTitle>
          <Paragraph>
            当您使用我们的服务时，我们可能收集您的浏览记录、搜索历史、收藏内容等，以便为您提供个性化推荐。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>1.3 设备信息</SubSectionTitle>
          <Paragraph>
            我们会收集您的设备型号、操作系统版本、设备标识符等信息，用于保障服务的安全稳定运行。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>二、我们如何共享、转让、公开披露您的个人信息</SectionTitle>
        
        <SubSection>
          <SubSectionTitle>2.1 共享</SubSectionTitle>
          <Paragraph>
            未经您同意，我们不会与任何第三方共享您的个人信息，但以下情况除外：
          </Paragraph>
          <BulletList>
            <BulletItem>根据法律法规或监管机构的要求；</BulletItem>
            <BulletItem>为提供服务所必需的合作伙伴；</BulletItem>
            <BulletItem>获得您的明确同意。</BulletItem>
          </BulletList>
        </SubSection>

        <SubSection>
          <SubSectionTitle>2.2 转让</SubSectionTitle>
          <Paragraph>
            我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：
          </Paragraph>
          <BulletList>
            <BulletItem>获得您的明确同意；</BulletItem>
            <BulletItem>在涉及合并、收购或破产清算时，如涉及个人信息转让，我们会要求新的持有您个人信息的公司继续受本政策约束。</BulletItem>
          </BulletList>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>三、我们如何保护您的个人信息</SectionTitle>
        
        <SubSection>
          <SubSectionTitle>3.1</SubSectionTitle>
          <Paragraph>
            我们已采取符合业界标准的安全防护措施保护您的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>3.2</SubSectionTitle>
          <Paragraph>
            我们会采取合理可行的措施，尽力避免收集无关的个人信息。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>3.3</SubSectionTitle>
          <Paragraph>
            我们会采用加密技术确保数据的机密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>四、您的权利</SectionTitle>
        <Paragraph>
          按照中国相关的法律法规，我们保障您对自己的个人信息行使以下权利：
        </Paragraph>
        
        <SubSection>
          <SubSectionTitle>4.1 访问权</SubSectionTitle>
          <Paragraph>
            您有权访问您的个人信息，法律法规规定的例外情况除外。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>4.2 更正权</SubSectionTitle>
          <Paragraph>
            当您发现我们处理的关于您的个人信息有错误时，您有权要求我们更正。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>4.3 删除权</SubSectionTitle>
          <Paragraph>
            在以下情形中，您可以向我们提出删除个人信息的请求：
          </Paragraph>
          <BulletList>
            <BulletItem>我们处理个人信息的行为违反法律法规的；</BulletItem>
            <BulletItem>我们收集、使用您的个人信息，却未征得您的同意；</BulletItem>
            <BulletItem>我们处理个人信息的行为违反了与您的约定。</BulletItem>
          </BulletList>
        </SubSection>

        <SubSection>
          <SubSectionTitle>4.4 撤回同意权</SubSectionTitle>
          <Paragraph>
            您可以通过删除信息、关闭设备功能等方式撤回您的同意。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>4.5 注销账户权</SubSectionTitle>
          <Paragraph>
            您可以在应用内申请注销账户。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>五、我们如何处理儿童的个人信息</SectionTitle>
        
        <SubSection>
          <SubSectionTitle>5.1</SubSectionTitle>
          <Paragraph>
            我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不应创建自己的账户。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>5.2</SubSectionTitle>
          <Paragraph>
            如果我们发现在未获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
          </Paragraph>
        </SubSection>
      </Section>

      <Section>
        <SectionTitle>六、本政策如何更新</SectionTitle>
        
        <SubSection>
          <SubSectionTitle>6.1</SubSectionTitle>
          <Paragraph>
            我们可能会适时修改本政策。未经您明确同意，我们不会削减您按照本政策所应享有的权利。
          </Paragraph>
        </SubSection>

        <SubSection>
          <SubSectionTitle>6.2</SubSectionTitle>
          <Paragraph>
            对于重大变更，我们会提供显著的通知（包括对于某些服务，我们会通过应用内通知的方式进行告知）。
          </Paragraph>
        </SubSection>
      </Section>

      <ContactInfo>
        <ContactTitle>联系我们</ContactTitle>
        <Paragraph>
          如果您对本隐私政策有任何疑问、意见或建议，请通过以下方式联系我们：
        </Paragraph>
        <ContactItem>客服邮箱：chuji_fun@163.com</ContactItem>
        <ContactItem>公司名称：湖州厨记科技有限公司</ContactItem>
      </ContactInfo>
    </Container>
  );
};

export default PrivacyPolicy;
